import { SideImage } from '../../components/SideImage';
import { PageSection } from '../../components/Section';
import { SkeletonCard, SkeletonRow } from '../../components/SkeletonCard';
import { DesktopOnly, MobileOnly } from '../../components/Layout';
import { ContentPanel } from '../../composites/ContentPanel';
import { SplitLayout } from '../../composites/SplitLayout';
import type { SpaDayDetailTemplateProps } from './SpaDayDetailTemplate.types';

export function SpaDayDetailTemplate({
  imageUrl,
  imageAlt,
  title,
  price,
  priceLabel,
  categoryLabel,
  description,
  termsContent,
  termsLabel,
  onReserve,
  reserveLabel,
  onBack,
  recommendations,
  isLoading,
  journeyBar,
}: SpaDayDetailTemplateProps) {
  const showRecommendations = isLoading || !!recommendations;

  return (
    <>
      <SplitLayout
        left={
          <SideImage
            src={imageUrl}
            alt={imageAlt}
            sticky
            onBack={onBack}
            overlayContent={journeyBar ? <MobileOnly>{journeyBar}</MobileOnly> : undefined}
          />
        }
        right={
          <>
            {journeyBar && <DesktopOnly>{journeyBar}</DesktopOnly>}
            <ContentPanel
              title={title}
              price={price}
              priceLabel={priceLabel}
              categoryLabel={categoryLabel}
              description={description}
              termsContent={termsContent}
              termsLabel={termsLabel}
              onReserve={onReserve}
              reserveLabel={reserveLabel}
              isLoading={isLoading}
            />
          </>
        }
      />

      {showRecommendations && (
        <PageSection>
          {isLoading ? (
            <SkeletonRow>
              {Array.from({ length: 4 }).map((_, i) => (
                <SkeletonCard key={i} variant="grid" />
              ))}
            </SkeletonRow>
          ) : (
            recommendations
          )}
        </PageSection>
      )}
    </>
  );
}
